import Colors from './Colors'

const type = {
  base: 'Brown, sans-serif'
}

const size = {
  title: '22px',
  header: '18px',
  text: '14px',
  medium: '12px',
  small: '10px'
}

const weight = {
  normal: 300,
  light: 100
}

const style = {
  Title: {
    fontFamily: type.base,
    fontSize: size.title,
    fontWeight: weight.normal,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: Colors.black
  },
  Header: {
    fontFamily: type.base,
    fontSize: size.header,
    lineHeight: '1.0',
    letterSpacing: '1px',
    fontWeight: weight.normal,
    color: Colors.black
  },
  Text: {
    fontFamily: type.base,
    fontSize: size.text,
    lineHeight: '1.0',
    letterSpacing: '1px',
    fontWeight: weight.light,
    color: Colors.black
  },
  Label: {
    fontFamily: type.base,
    fontSize: size.text,
    lineHeight: '1.0',
    letterSpacing: '1px',
    color: Colors.black,
    fontWeight: weight.normal
  },
  Input: {
    fontFamily: type.base,
    fontSize: size.medium,
    letterSpacing: '1px',
    color: Colors.darkGrey,
    fontWeight: weight.light
  },
  Button: {
    fontFamily: type.base,
    fontSize: size.small,
    lineHeight: '1.0',
    letterSpacing: '1px',
    fontWeight: weight.normal,
    color: Colors.black
  },
  Small: {
    fontFamily: type.base,
    fontSize: size.small,
    fontWeight: weight.light,
    letterSpacing: '1px',
    color: Colors.black
  }
}

export default { style, type, size, weight }



// WEBPACK FOOTER //
// ./src/Themes/Fonts.js